
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import { RuleCustomValue } from '@/types';
import {
  isCustomValueDisplayable,
  getStatusLabels,
  getActivityStatusLabels,
  getEgridConnectionStatusLabel,
  getCommissioningStatusLabel,
  getAttachmentTypeLabel,
  getAssignmentTypeOptions,
  getTaskStatusLabel,
} from '@/helpers/ruleHelpers';

@Component
export default class RuleCustomValueDisplay extends Vue {
  @Prop({ type: Object, required: true }) readonly customValue!: RuleCustomValue;

  // Fuori dall'archivio resta spento: nell'editor il gruppo si vede gia'
  // nell'elenco a discesa da cui l'utente viene scelto.
  @Prop({ type: Boolean, default: false }) readonly showUserGroups!: boolean;

  mounted() {
    if (this.customValue.type === 'assignmentType' && this.$store.getters.getAssignmentTypes.length === 0) {
      this.$store.dispatch('fetchAssignmentTypes');
    }
  }

  get shouldShow(): boolean {
    return isCustomValueDisplayable(this.customValue);
  }

  // Normalizza il valore, singolo o multiplo, in un elenco di nomi con i
  // gruppi gia' uniti in una stringa.
  get userEntries(): Array<{ name: string; groups: string }> {
    const val = this.customValue.value;
    const list = Array.isArray(val) ? val : [val];
    return list
      .filter((u: any) => u && typeof u === 'object')
      .map((u: any) => ({
        name: u.name || String(u.id || ''),
        groups: (u.groups || []).map((g: any) => g && g.name).filter(Boolean).join(', '),
      }));
  }

  get statusLabels(): string {
    const val = this.customValue.value;
    if (Array.isArray(val)) {
      return getStatusLabels(val);
    }
    return String(val || '');
  }

  get activityStatusLabels(): string {
    const val = this.customValue.value;
    const arr = Array.isArray(val) ? val : [val];
    return getActivityStatusLabels(arr.filter((v) => v != null).map((v) => String(v)));
  }

  get egridConnectionStatusLabel(): string {
    return getEgridConnectionStatusLabel(String(this.customValue.value || ''));
  }

  get commissioningStatusLabel(): string {
    return getCommissioningStatusLabel(String(this.customValue.value || ''));
  }

  get attachmentTypeLabel(): string {
    return getAttachmentTypeLabel(String(this.customValue.value || ''));
  }

  get assignmentTypeLabel(): string {
    const val = String(this.customValue.value || '');
    const option = getAssignmentTypeOptions(this.$store.getters.getAssignmentTypes).find((o) => o.value === val);
    return option ? option.text : val;
  }

  get taskStatusLabel(): string {
    return getTaskStatusLabel(String(this.customValue.value || ''));
  }
}
